import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  iataCodeService,
  type CreateIataCodeRequest,
  type UpdateIataCodeRequest,
} from '../../services/api/iataCodeService';

// --- IATA Code Thunks ---

export const fetchIataCodes = createAsyncThunk(
  'iataCode/fetchIataCodes',
  async ({ searchText, status, codeType, pageNumber, pageSize, sortBy, sortDirection }: {
    searchText?: string; status?: string; codeType?: string; pageNumber?: number; pageSize?: number; sortBy?: string; sortDirection?: string;
  }, { rejectWithValue }) => {
    try {
      return await iataCodeService.getIataCodes(searchText, status, codeType, pageNumber, pageSize, sortBy, sortDirection);
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : 'Failed to fetch IATA codes');
    }
  }
);

export const fetchActiveIataCodes = createAsyncThunk(
  'iataCode/fetchActiveIataCodes',
  async ({ type }: { type?: string } = {}, { rejectWithValue }) => {
    try {
      return await iataCodeService.getActiveIataCodes(type);
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : 'Failed to fetch active IATA codes');
    }
  }
);

export const createIataCode = createAsyncThunk(
  'iataCode/createIataCode',
  async (request: CreateIataCodeRequest, { rejectWithValue }) => {
    try {
      return await iataCodeService.createIataCode(request);
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : 'Failed to create IATA code');
    }
  }
);

export const updateIataCode = createAsyncThunk(
  'iataCode/updateIataCode',
  async ({ id, request }: { id: number; request: UpdateIataCodeRequest }, { rejectWithValue }) => {
    try {
      return await iataCodeService.updateIataCode(id, request);
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : 'Failed to update IATA code');
    }
  }
);

export const deleteIataCode = createAsyncThunk(
  'iataCode/deleteIataCode',
  async ({ id }: { id: number }, { rejectWithValue }) => {
    try {
      await iataCodeService.deleteIataCode(id);
      return id;
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : 'Failed to delete IATA code');
    }
  }
);

export const activateIataCode = createAsyncThunk(
  'iataCode/activateIataCode',
  async ({ id }: { id: number }, { rejectWithValue }) => {
    try {
      await iataCodeService.activateIataCode(id);
      return id;
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : 'Failed to activate IATA code');
    }
  }
);

export const deactivateIataCode = createAsyncThunk(
  'iataCode/deactivateIataCode',
  async ({ id }: { id: number }, { rejectWithValue }) => {
    try {
      await iataCodeService.deactivateIataCode(id);
      return id;
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : 'Failed to deactivate IATA code');
    }
  }
);
